import React from 'react';
import './BlogThumbnail.css';

const BlogThumbnail = ({ imageSrc, title, description, linkRoute }) => {
  return (
    <a href={linkRoute} className="thumbnail-link">
      <div className="blog-thumbnail">
        <img src={imageSrc} alt={title} className="thumbnail-image" />
        <h2 className="thumbnail-title">{title}</h2>
        <div className="thumbnail-content">
          <p className="thumbnail-description">{description}</p>
        </div>
      </div>
    </a>
  );
};

export default BlogThumbnail;
